import {createStore} from 'vuex'

export default createStore({
    state: {
        city: {},
        account: {}
    },
    getters: {},
    mutations: {
        getCity(state, playLoad) {
            if (!playLoad) {
                const city = window.sessionStorage.getItem("cityInfo");
                if (!city) {
                    this.state.city = {}
                } else {
                    this.state.city = JSON.parse(city)
                }
            } else {
                this.state.city = playLoad
                window.sessionStorage.setItem("cityInfo", JSON.stringify(playLoad))
            }
        },
        getAccount(state, playLoad) {
            if (!playLoad) {
                const user = window.sessionStorage.getItem("account")
                this.state.account = {}
                if (user) {
                    this.state.account = JSON.parse(user)
                }
            } else {
                window.sessionStorage.setItem("account", JSON.stringify(playLoad));
                this.state.account = playLoad
            }
        },
        removeAccount(state) {
            window.sessionStorage.removeItem("account")
            this.state.account = {}
        }
    },
    actions: {},
    modules: {}
})
